
import { useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { deepCopy } from "../../../../../../../common/services/common.service";
import { associatedCampaignDSAPMapping } from "../../../../../../../redux/associated-campaign-dsap-mappings/action";
import { smsCampaigns } from "../../../../../../../redux/sms-campaigns/action";
import CampaignSmsInfoComponent from "./campaign-sms-info.component";



export const PrepareSmsCampaign = ({
    agents,
    choosenCampaign,
    id,
    customerTags,
    campaignFrequency,
    paginationData,
    choosenEmailPlan,
    setSelectedTemplate,
    selectedTemplate,
    choosenTemplate,
    rowData,
    columnDefs,
    setPageData,
    vendorRowData,
    VendorpaginationData,
    vendorColumnDefs
}: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [campaign, setCampaign] = useState<any>(choosenCampaign);
    const [emailPlan, setEmailPlan] = useState<any>(choosenEmailPlan);
    const [selectedPlanId, setSelectedPlanId] = useState<any>(null);
    useEffect(() => {
        if (id > 0) {
            setCampaign(choosenCampaign);
        }
    }, [id, choosenCampaign]);
    
    const handlePlanIdChange = (planId: any) => {
        setSelectedPlanId(planId); // assuming setSelectedPlanId is defined using useState
    };
    const handleInnerFormChange: any = (event: any, field: string) => {
        setCampaign({ ...campaign, [field]: event });
    };

    const handlePlanSelect = (data: any) => {
        setEmailPlan(data);
    };

    const close = () => {
        navigate('/agencies/promotions/marketing/campaign')
    };
    
    const handleSubmit = () => {
    
        const localChoosenCampaign = deepCopy(campaign);
        localChoosenCampaign.SMSPlanId = selectedPlanId;
        localChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
        const updateChoosenCampaign = deepCopy(campaign);
        updateChoosenCampaign.SMSPlanId = selectedPlanId;
        updateChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
    

        const dsapMapping= {
            DSAPId: updateChoosenCampaign?.DSAPId,
            MappedCampaignId: id
        }
        if (id > 0) {
                dispatch(
                    associatedCampaignDSAPMapping.create({
                        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/associated-campaign-dsap-mappings`,
                        entity: "associatedCampaignDSAPMapping",
                        jsonData: {
                            Records: [dsapMapping],
                        },
                    })
                );
              
            updateSmsMarketingCampaign(updateChoosenCampaign);
        } else {
            createSmsMarketingCampaign(localChoosenCampaign);
        }
    };

    const handleSubmitNow = () => {
   
        const localChoosenCampaign = deepCopy(campaign);
        localChoosenCampaign.SMSPlanId =selectedPlanId;
        localChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
            const updateChoosenCampaign = deepCopy(campaign);
        updateChoosenCampaign.SMSPlanId = selectedPlanId;
        updateChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
      
         if (id > 0) {
            updateSmsMarketingCampaign(updateChoosenCampaign);
            runSmsMarketingCampaign()
        } else {
            createSmsMarketingCampaign(localChoosenCampaign);
            runSmsMarketingCampaign()
        }
    };

    const createSmsMarketingCampaign = (localChoosenCampaign: any) => {
        dispatch(
            smsCampaigns.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns`,
                entity: "smsCampaigns",
                jsonData: {
                    Records: [localChoosenCampaign],
                },
            })
        );
        navigate("/agencies/promotions/marketing/campaign");
    };

    const updateSmsMarketingCampaign = (localChoosenCampaign: any) => {
        console.log(localChoosenCampaign, "localChoosenCampaign");
        dispatch(
            smsCampaigns.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns`,
                entity: "smsCampaigns",
                jsonData: {
                    Records: [localChoosenCampaign],
                },
            })
        );
        navigate("/agencies/promotions/marketing/campaign");
    };

    const runSmsMarketingCampaign = () => {
    
            dispatch(
                smsCampaigns.create({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/schedule-campaigns/send-campaign`,
                    entity: "smsCampaigns",
                    jsonData: {
                        Records: [{}],
                    },
                })
            );
      
        navigate("/agencies/promotions/marketing/campaign");
    };

    return (
        <div className="flex w-full justify-center items-center">
            <div className="w-full p-2 bg-white shadow-md rounded-md">
                <h1 className="text-xl font-bold mb-4 text-center">
                    {campaign?.Id ? "Edit Campaign" : "Create SMS Campaign"}
                </h1>
                <div className="flex flex-col gap-4">
                    <CampaignSmsInfoComponent
                        choosenCampaign={campaign}
                        campaignFrequency={campaignFrequency}
                        customerTags={customerTags}
                        choosenEmailPlan={emailPlan}
                        emailBudget={{}}
                        emailNotes={{}}
                        setSelectedTemplate={setSelectedTemplate}
                        selectedTemplate={selectedTemplate}
                        choosenTemplate={choosenTemplate}
                        handlePlanSelect={handlePlanSelect}  
                        handleInnerFormChange={handleInnerFormChange}
                        onPlanIdChange={handlePlanIdChange} // New prop
                        rowData={rowData}
                        columnDefs={columnDefs}
                        setPageData={setPageData}
                        paginationData={paginationData}
                        vendorRowData={vendorRowData}
                        VendorpaginationData={VendorpaginationData}
                        vendorColumnDefs={vendorColumnDefs}
                        agents={agents}
                    />
                </div>
                <div className="text-end">
                    <button
                        onClick={close}
                        type="button"
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    >
                        Back
                    </button>
                    <button
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                        onClick={handleSubmitNow}
                        type="submit"
                    >
                        Save & Send Now
                    </button>
                    <button
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                        onClick={handleSubmit}
                        type="submit"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};
